import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { configBonusList, configBonusHandle, refreshGift } from '@/api/apis';
export default {
  name: 'index',
  data: function data() {
    return {
      activeName: '1',
      bonus1_0: [],
      bonus1_1: [],
      bonus2_0: [],
      bonus2_1: [],
      id1: '',
      id2: '',
      bonusData: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    configBonusList().then(function _callee(res) {
      var data, i;
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = res.rows;
              _this.bonusData = data;

              for (i in data) {
                if (data[i].tag == 0) {
                  _this.bonus1_0 = JSON.parse(data[i].conditions);
                  _this.bonus1_1 = JSON.parse(data[i].exa_cond);
                  _this.id1 = data[i].id;
                } else if (data[i].tag == 1) {
                  _this.bonus2_0 = JSON.parse(data[i].conditions);
                  _this.bonus2_1 = JSON.parse(data[i].exa_cond);
                  _this.id2 = data[i].id;
                }
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      });
    });
  },
  methods: {
    getGradeName: function getGradeName(index) {
      if (index === 0) {
        return '区代理';
      } else if (index === 1) {
        return '市代理';
      } else if (index === 2) {
        return '省代理';
      } else if (index === 3) {
        return '大区经理';
      } else if (index === 4) {
        return '高级大区经理';
      } else if (index === 5) {
        return '总代理';
      }
    },
    handlePriceInput: function handlePriceInput(value, data, key) {
      // 允许的格式为数字并最多保留两位小数
      var formattedValue = value.replace(/[^\d.]/g, '') // 去除非数字和小数点的字符
      .replace(/^0+(\d)/, '$1') // 去除多余的前导零，但保留 "0." 形式
      .replace(/^\./, '0.') // 如果第一个字符是 "."，则改为 "0."
      .replace(/(\.\d{3})\d+/, '$1'); // 限制小数点后最多两位
      // 保证只能有一个小数点

      var dotIndex = formattedValue.indexOf('.');

      if (dotIndex !== -1) {
        formattedValue = formattedValue.slice(0, dotIndex + 1) + formattedValue.slice(dotIndex + 1).replace(/\./g, '');
      }

      data[key] = formattedValue;
    },
    clickSave1: function clickSave1() {
      var _this2 = this;

      var tmp1 = [];
      var tmp2 = [];

      for (var i in this.bonus1_0) {
        tmp1.push({
          bonus: parseInt(this.bonus1_0[i].bonus)
        });
      }

      for (var i in this.bonus1_1) {
        tmp2.push({
          bonus: parseInt(this.bonus1_1[i].bonus)
        });
      }

      configBonusHandle({
        id: this.id1,
        conditions: JSON.stringify(tmp1),
        exa_cond: JSON.stringify(tmp2)
      }).then(function _callee2(res) {
        return regeneratorRuntime.async(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$alert('保存成功', '提示', {
                  confirmButtonText: '确定'
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        });
      });
    },
    clickSave2: function clickSave2() {
      var _this3 = this;

      var tmp1 = [];
      var tmp2 = [];

      for (var i in this.bonus2_0) {
        tmp1.push({
          bonus: parseInt(this.bonus2_0[i].bonus)
        });
      }

      for (var i in this.bonus2_1) {
        tmp2.push({
          bonus: parseInt(this.bonus2_1[i].bonus)
        });
      }

      configBonusHandle({
        id: this.id2,
        conditions: JSON.stringify(tmp1),
        exa_cond: JSON.stringify(tmp2)
      }).then(function _callee3(res) {
        return regeneratorRuntime.async(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$alert('保存成功', '提示', {
                  confirmButtonText: '确定'
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        });
      });
    }
  }
};